// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'
import FBSignInButton from 'vue-facebook-signin-button'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// import './assets/bootstrap.css'
// import 'font-awesome/css/font-awesome.min.css'

Vue.config.productionTip = false
Vue.use(VueAnalytics, {
  id: 'UA-117996018-1',
  router
})
Vue.use(Vuex)
Vue.use(FBSignInButton)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js